import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { OrderStatus, OrderSummary } from "@/components/OrderSummary";
import { errText, lookupOrder } from "@/lib/api";

export default function OrderLookup() {
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { setOrder(await lookupOrder({ email, order_number: number })); } catch (err) { setOrder(null); setError(errText(err)); }
    setBusy(false);
  };

  return (
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 pb-28 pt-14 sm:px-10 lg:grid-cols-12 lg:pt-24" data-testid="order-lookup-page">
      <Seo title="Order lookup" description="Check the status of your order from the suspects." path="/order-lookup" noindex />
      <div className="lg:col-span-5">
        <p className="label text-ink/60">Guest orders</p>
        <h1 className="display mt-5 text-[clamp(3.5rem,8vw,7rem)]">Order <span className="hl hl-pink hl-thick">lookup</span></h1>
        <p className="mt-6 max-w-sm text-[15px] text-ink/70">Enter the email you checked out with and your order number (it looks like SUS-XXXXXX).</p>
        <form onSubmit={submit} className="mt-10 max-w-md space-y-6" data-testid="order-lookup-form">
          <label className="block"><span className="label text-ink/60">Email</span><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="order-lookup-email" /></label>
          <label className="block"><span className="label text-ink/60">Order number</span><input required value={number} onChange={(e) => setNumber(e.target.value)} placeholder="SUS-ABC234" className="field uppercase" data-testid="order-lookup-number" /></label>
          {error && <p className="text-sm text-alert" data-testid="order-lookup-error">{error}</p>}
          <button disabled={busy} className="btn btn-ink" data-testid="order-lookup-submit">{busy ? "Looking…" : "Find my order"} <ArrowRight size={16} /></button>
        </form>
      </div>
      {order && (
        <div className="lg:col-span-6 lg:col-start-7" data-testid="order-lookup-result">
          <div className="mb-6 flex items-center justify-between gap-4"><p className="display text-4xl">{order.order_number}</p><OrderStatus status={order.status} /></div>
          <OrderSummary order={order} />
        </div>
      )}
    </div>
  );
}
